import { Badge } from '@/components/ui/Badge';
import type { ExecutionStepStatus, FlowExecutionStatus } from '@shared/types/flow-executions';

type ExecutionStatus = ExecutionStepStatus | FlowExecutionStatus | string;

interface ExecutionStatusBadgeProps {
  status: ExecutionStatus;
}

export const ExecutionStatusBadge = ({ status }: ExecutionStatusBadgeProps) => {
  switch (status) {
    case 'completed':
      return <Badge variant="success">Terminé</Badge>;
    case 'running':
      return <Badge variant="warning">En cours</Badge>;
    case 'failed':
      return <Badge variant="error">Erreur</Badge>;
    case 'waiting_hitl':
      return <Badge variant="warning">En attente</Badge>;
    case 'paused':
      return <Badge variant="warning">En pause</Badge>;
    case 'skipped':
      return <Badge variant="outline">Ignoré</Badge>;
    case 'cancelled':
      return <Badge variant="secondary">Annulé</Badge>;
    case 'pending':
    default:
      return <Badge variant="secondary">En attente</Badge>;
  }
};
